// MarkAttendanceModal.js

import React, { useState, useRef, useEffect } from "react";
import {
  Modal,
  Box,
  Typography,
  Button,
  ListItemIcon,
  Tooltip,
  ListItemButton,
} from "@mui/material";
import moment from "moment";
import LibraryAddCheckIcon from "@mui/icons-material/LibraryAddCheck";
import UserIconImage from "../image/UserIconImage.png";
import { BASE_URL, DOMAIN } from "../../global";
import { toast } from "react-toastify";
import axiosWithToken from "../../utils/commonComponent/axiosTokenConfig";
import { AddButton } from "../../utils/commonComponent/Custom/Button";
import { MdPlayArrow, MdLocationPin } from "react-icons/md";
import { MdCheckCircle } from "react-icons/md";
import { MdAccessTime } from "react-icons/md"; // clock
import { MdPlace } from "react-icons/md"; // location pin
import { MdMyLocation } from "react-icons/md"; // lat/long
import { MdExitToApp } from "react-icons/md"; // punch-out
import { MdLogin } from "react-icons/md";
import LoaderModal from "../../utils/loader.js/loader";

const multiValueModalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 550,
  "@media (max-width: 600px)": { width: "80%" },
  "@media (max-width: 480px)": { width: "90%" },
  bgcolor: "background.paper",
  // border: "2px solid #000",
   borderRadius: "20px",
  boxShadow: 24,
  maxHeight: "550px",
  overflow: "auto",
  padding: "10px 30px",
};

const MarkAttendanceModal = ({ isMobile }) => {
  const [open, setOpen] = useState(false);
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [imageData, setImageData] = useState(null);
  const [cameraActive, setCameraActive] = useState(false);
  const [uploadedImageUrl, setUploadedImageUrl] = useState(null);
  const [isCheckIn, setIsCheckIn] = useState(true);
  const [isCheckOut, setIsCheckOut] = useState(false);
  const [attendanceId, setAttendanceId] = useState(null);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [cameraStream, setCameraStream] = useState(null);
  const [successModalOpen, setSuccessModalOpen] = useState(false);
  const [punchType, setPunchType] = useState("");
  const [locationName, setLocationName] = useState("");

  const userId = localStorage.getItem("id");
  const _employeeId = Number(localStorage.getItem("employeeId"));
  const _userType = Number(localStorage.getItem("type"));
  const videoRef = useRef(null);

  const [downloadPdfloading, setDownlaodPdfLoading] = useState(false);

  const handleStartCamera = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });

      setCameraStream(stream);
      setCameraActive(true);

      const video = videoRef.current;
      video.srcObject = stream;

      // Wait until camera is ready
      // video.onloadedmetadata = () => {
      //   video.play();
      //   setTimeout(() => {
      //     handleCapturePhoto();
      //   }, 500); // Now it captures correctly
      // };
    } catch (error) {
      console.error("Error accessing camera:", error);
    }
  };

  useEffect(() => {
    if (cameraActive && videoRef.current && cameraStream) {
      videoRef.current.srcObject = cameraStream;
    }
  }, [cameraActive, cameraStream]);

  const stopCameraStream = () => {
    if (cameraStream) {
      const tracks = cameraStream.getTracks();
      tracks.forEach((track) => track.stop());
      setCameraStream(null);
    }
  };

  const handleCapturePhoto = async() => {
    try {
      const canvas = document.createElement("canvas");
      const video = videoRef.current;
      if (video) {
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        canvas
          .getContext("2d")
          .drawImage(video, 0, 0, canvas.width, canvas.height);

        const imageUrl = canvas.toDataURL("image/jpeg");
       const uploadedImageUrl = await handleUploadPhoto(imageUrl);
        setImageData(imageUrl);
        setCameraActive(false);

        stopCameraStream();
        return uploadedImageUrl;
      }
    } catch (error) {
      console.error("Error capturing photo:", error);
    }
  };

  const handleUploadPhoto = async (imageUrl) => {
    setDownlaodPdfLoading(true);
    try {
      const uploadedImageUrl = await handleFileUpload12(imageUrl);
      setUploadedImageUrl(uploadedImageUrl);
      setDownlaodPdfLoading(false);
      setCameraActive(false);
      return uploadedImageUrl;
    } catch (error) {
      console.error("Error uploading photo:", error);
      setDownlaodPdfLoading(false);
    }
  };

  const handleFileUpload12 = async (imageData) => {
    const byteCharacters = atob(imageData.split(",")[1]);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: "image/jpeg" });

    const data = new FormData();
    data.append("fileToUpload", blob, "images.jpg");

    try {
      const res = await axiosWithToken.post(
        BASE_URL + "fileUpload/fileUpload.php",
        data
      );
      if (res.status === 200 || res.status === 201) {
        return `${res.data}`;
      } else {
        toast.error("Something Went Wrong! for Image Upload");
      }
    } catch (err) {
      console.error("Error uploading file:", err);
      toast.error(`Error: ${err.message}`);
      throw err;
    }
  };

  const handleOpen = () => {
    getLocation();
    setOpen(true);
    handleStartCamera();
  };

  const handleClose = () => {
    setOpen(false);
    setCameraActive(false);
    stopCameraStream();
    setImageData(null);
    setUploadedImageUrl(null);
  };

  var refresh = () => window.location.reload(false);

  const getLocation = () => {
    if (navigator.geolocation) {
        setDownlaodPdfLoading(true);
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLatitude(position.coords.latitude);
          setLongitude(position.coords.longitude);
            setDownlaodPdfLoading(false);
        },
        (err) => {
          console.log(err.message);
        }
      );
    } else {
      console.log("Geolocation is not supported by this browser.");
    }
  };

  const handleSubmit = async() => {


   const uploadedImageUrl1 = await handleCapturePhoto();

    // 🔥 Wait until uploadedImageUrl is actually updated
  // while (!uploadedImageUrl) {
  //   await new Promise((resolve) => setTimeout(resolve, 200));
  // }

    let checkInPayload = {
      userId: userId,
      employeeId: _employeeId,
      checkinPhotoPath: uploadedImageUrl1,
      checkinLat: latitude,
      checkinLang: longitude,
    };

    let checkOutPayload = {
      userId: userId,
      employeeId: _employeeId,
      checkoutPhoto: uploadedImageUrl1,
      checkoutLat: latitude,
      checkoutLang: longitude,
      checkoutDatetime: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
    };

    let url = BASE_URL;

    // -----------------------
    // PUNCH OUT
    // -----------------------
    if (attendanceId && !isCheckIn) {
      axiosWithToken
        .patch(url + `attendance/${attendanceId}`, checkOutPayload)
        .then(() => {
          setPunchType("Punch-Out"); // 🔥 set punch type
          // handleClose();
          setSuccessModalOpen(true); // open success screen
        })
        .catch((err) => {
          toast.error(`Error: ${err.message}`);
        });

      return;
    }

    // -----------------------
    // PUNCH IN
    // -----------------------
    axiosWithToken
      .post(url + `attendance`, checkInPayload)
      .then(() => {
        setPunchType("Punch-In"); // 🔥 set punch type
        // handleClose();
        setSuccessModalOpen(true); // open success screen
      })
      .catch((err) => {
        toast.error(`Error: ${err.message}`);
      });
  };

  const fetchData = () => {
    let sqlQuery = {
      query: `SELECT * FROM attendance WHERE userId = ${userId} AND DATE(checkinDatetime) = CURDATE() and status=1 ORDER BY id DESC`,
    };

    axiosWithToken
      .post(BASE_URL + `dynamic`, sqlQuery)
      .then((res) => {
        setAttendanceId(res?.data?.[0]?.id);
        if (res?.data?.length > 0) {
          if(res?.data?.[0]?.checkoutLat){
            setIsCheckOut(true);
          }
          if (res?.data?.[0]?.checkoutPhoto) {
            setIsCheckIn(true);
          } else {
            setSelectedLocation(res?.data?.[0]?.addressId);
            setIsCheckIn(false);
          }
        }
      })
      .catch((err) => toast.error(`Error: ${err.message}`));
  };

  const validateData = () => {
    if (!longitude) {
      // toast.error("Please give permission to take your location");
       setDownlaodPdfLoading(true);
      return false;
    }
     setDownlaodPdfLoading(false);
    return true;
  };

  const toDMS = (decimal, isLat = true) => {
    const dir = decimal >= 0 ? (isLat ? "N" : "E") : isLat ? "S" : "W";

    const absValue = Math.abs(decimal);
    const degrees = Math.floor(absValue);
    const minutesDecimal = (absValue - degrees) * 60;
    const minutes = Math.floor(minutesDecimal);
    const seconds = Math.round((minutesDecimal - minutes) * 60);

    return `${degrees}° ${minutes}' ${seconds}" ${dir}`;
  };

  const latDMS = toDMS(latitude, true);
  const longDMS = toDMS(longitude, false);



  const fetchLocationName = async (lat, lon) => {
    try {
      const response = await fetch(
        `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}`
      );
      const data = await response.json();
      setLocationName(data?.display_name || "Unknown Location");
    } catch (e) {
      console.error("Location fetch failed", e);
      setLocationName("Unknown Location");
    }
  };

  useEffect(() => {
    if (latitude && longitude) {
      fetchLocationName(latitude, longitude);
    }
  }, [latitude, longitude]);

  useEffect(() => {
    fetchData();
  }, []);

  console.log("isCheckIn",isCheckIn)

  return (
    <div>
      {!isMobile ? (
        <Button onClick={handleOpen}>
          <LibraryAddCheckIcon className="mr-2" />
          Mark Attendance
        </Button>
      ) : (
        <ListItemButton onClick={handleOpen}>
          <ListItemIcon>
            <Tooltip title="Mark Attendance" arrow placement="right">
              <LibraryAddCheckIcon />
            </Tooltip>
          </ListItemIcon>
          <Typography variant="p" component="div" align="left">
            {"Mark Attendance"}
          </Typography>
        </ListItemButton>
      )}

      <Modal open={open} onClose={handleClose}>
        <Box sx={multiValueModalStyle}>
          {/* Date + Time */}
          <Box sx={{ textAlign: "center" }}>
            <Typography variant="h6">
              {new Date().toLocaleDateString("en-US", {
                weekday: "short",
                day: "2-digit",
                month: "short",
                year: "numeric",
              })}
            </Typography>

            {/* <br /> */}
            <hr />
            <br />

            <Typography
              variant="h4"
              sx={{
                fontWeight: "bold",
                position: "relative",
                display: "inline-block",
              }}
            >
              {new Date()
                .toLocaleTimeString("en-US", {
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: true,
                })
                .replace(/AM|PM/, "")}

              <sup
                style={{
                  fontSize: 12,
                  position: "absolute",
                  top: -6,
                  right: -22,
                }}
              >
                {new Date()
                  .toLocaleTimeString("en-US", { hour12: true })
                  .slice(-2)}
              </sup>
            </Typography>
          </Box>

          <Box
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              marginBottom: "5px",
              padding: "5px",
            }}
          >
            {/* Video always rendered */}
            <video
              ref={videoRef}
              autoPlay
              playsInline
              muted
              style={{
                height: "200px",
                width: "100%",
                display: cameraActive ? "block" : "none",
                background: "black",
              }}
            />

            {!cameraActive && (
              <img
                src={uploadedImageUrl || imageData || UserIconImage}
                style={{ height: "200px", width: "80%", marginBottom: "2px" }}
                alt="User Icon"
              />
            )}
          </Box>

          <Box>
            {/* Welcome */}
            <Typography
              variant="h6"
              sx={{
                textAlign: "center",
                borderBottom: "1px solid #ccc",
                pb: 1,
                mb: 2,
                fontWeight: "bold",
              }}
            >
              Welcome!
            </Typography>

            {/* LAT + LONG Row */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
              <MdPlayArrow size={20} color="red" /> {/* Icon */}
              <Typography sx={{ color: "black", fontSize: "14px" }}>
                <strong>Lat:</strong> {latDMS}
                <span style={{ marginLeft: "20px" }}>
                  <strong>Long:</strong> {longDMS}
                </span>
              </Typography>
            </Box>

            {/* LOCATION Row */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <MdLocationPin size={20} color="red" /> {/* Icon */}
              <Typography sx={{ color: "black", fontSize: "14px" }}>
                {locationName}
              </Typography>
            </Box>
          </Box>

          <Box
            style={{
              display: "flex",
              gap: "15px",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "10px",
            }}
          >
            <AddButton
              disabled={!isCheckIn}
              onClick={() => {
                if (!validateData()) return;
                handleSubmit();
              }}
              label="PUNCH IN"
            />

            <AddButton
              disabled={isCheckIn || isCheckOut}
              onClick={() => {
                if (!validateData()) return;
                handleSubmit();
              }}
              label="PUNCH OUT"
            />
          </Box>
        </Box>
      </Modal>

      <Modal
        open={successModalOpen}
        onClose={() => {
          setSuccessModalOpen(false);
          window.location.reload();
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 450,
            "@media (max-width: 600px)": { width: "80%" },
            "@media (max-width: 480px)": { width: "90%" },
            bgcolor: "background.paper",
            boxShadow: 24,
            maxHeight: "550px",
            overflow: "auto",
            padding: "10px 30px",
            borderRadius: "20px",
            position: "relative",
          }}
        >
          {/* Title */}
          <Typography
            sx={{
              textAlign: "center",
              fontWeight: "bold",
              mb: 1,
              fontSize: 18,
            }}
          >
            Your punch registered successfully.
          </Typography>



          {/* Success Icon */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              my: 2,
            }}
          >
            <MdCheckCircle size={50} color="#00c853" />
          </Box>

          <hr/>
          <br/>

          {/* Punch Type (Punch-In / Punch-Out) */}
          <Box sx={{ display: "flex", alignItems: "center", mb: 1, gap: 1 }}>
            {punchType === "Punch-In" ? (
              <MdLogin size={18} color="green" />
            ) : (
              <MdExitToApp size={18} color="red" />
            )}
            <Typography sx={{ fontWeight: "bold", color: "red", fontSize: 16 }}>
              {punchType}
            </Typography>
          </Box>

          {/* Date + Time */}
          <Box sx={{ display: "flex", alignItems: "center", mb: 1, gap: 1 }}>
            <MdAccessTime size={18} color="red" />
            <Typography sx={{ fontSize: 14 }}>
              {new Date().toLocaleDateString("en-US", {
                day: "2-digit",
                month: "short",
                year: "numeric",
              })}{" "}
              {new Date().toLocaleTimeString("en-US")}
            </Typography>
          </Box>

          {/* Lat + Long */}
          <Box sx={{ display: "flex", alignItems: "center", mb: 1, gap: 1 }}>
            <MdMyLocation size={18} color="red" />
            <Typography sx={{ fontSize: 14 }}>
              <strong>Lat:</strong> {latDMS} &nbsp;&nbsp;
              <strong>Long:</strong> {longDMS}
            </Typography>
          </Box>

          {/* Location */}
          <Box sx={{ display: "flex", alignItems: "center", mb: 1, gap: 1 }}>
            <MdPlace size={18} color="red" />
            <Typography sx={{ fontSize: 14 }}>{locationName}</Typography>
          </Box>

          {/* Bottom Close Button */}
          <Box sx={{ textAlign: "center", mt: 3 }}>
            <AddButton
              label="Close"
              onClick={() => {
                setSuccessModalOpen(false);
                window.location.reload();
              }}
            />
          </Box>
        </Box>
      </Modal>
       {downloadPdfloading && <LoaderModal loading={downloadPdfloading} />}
    </div>
  );
};

export default MarkAttendanceModal;
